// Website related settings
const settings = {
  isSplash: false,
};

// SEO remains static for simplicity (or handle dynamically via Helmet if needed later)
const seo = {
  title: "Amedee LOUGBEGNON Portfolio",
  description:
    "Focused on end-to-end products that develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Amédée LOUGBEGNON Portfolio",
    type: "website",
    url: "https://lougbegnon.github.io/",
  },
};

// Home Page
const greeting = {
  titleKey: "home.title",
  logo_name: "Amedee L.",
  nicknameKey: "home.nickname",
  subTitleKey: "home.subTitle",
  resumeLink: "https://drive.google.com/file/d/1bXRknv_h-XI_3CQ3SGPteGODtvEb7YvI/view?usp=sharing",
  portfolio_repository: "https://github.com/LOUGBEGNON/portfolio.git",
  githubProfile: "https://github.com/LOUGBEGNON",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/LOUGBEGNON",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/amedee-lougbegnon",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Gmail",
    link: "mailto:amedeelougbegnon3@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/share/1DefbrabtV/?mibextid=wwXIfr",
    fontAwesomeIcon: "fa-facebook-f",
    backgroundColor: "#1877F2",
  },
];

const skills = {
  data: [
    {
      titleKey: "skills.dataScience.title",
      fileName: "DataScienceImg",
      skillsKeys: [
        "skills.dataScience.skills.0",
        "skills.dataScience.skills.1",
        "skills.dataScience.skills.2",
      ],
      softwareSkills: [
        { skillName: "Tensorflow", fontAwesomeClassname: "logos-tensorflow", style: { backgroundColor: "transparent" } },
        { skillName: "Keras", fontAwesomeClassname: "simple-icons:keras", style: { backgroundColor: "white", color: "#D00000" } },
        { skillName: "PyTorch", fontAwesomeClassname: "logos-pytorch", style: { backgroundColor: "transparent" } },
        { skillName: "Python", fontAwesomeClassname: "ion-logo-python", style: { backgroundColor: "transparent", color: "#3776AB" } },
        { skillName: "Deeplearning", imageSrc: "deeplearning_ai_logo.png" },
      ],
    },
    {
      titleKey: "skills.fullStack.title",
      fileName: "FullStackImg",
      skillsKeys: [
        "skills.fullStack.skills.0",
        "skills.fullStack.skills.1",
        "skills.fullStack.skills.2",
      ],
      softwareSkills: [
        { skillName: "HTML5", fontAwesomeClassname: "simple-icons:html5", style: { color: "#E34F26" } },
        { skillName: "CSS3", fontAwesomeClassname: "fa-css3", style: { color: "#1572B6" } },
        { skillName: "Sass", fontAwesomeClassname: "simple-icons:sass", style: { color: "#CC6699" } },
        { skillName: "JavaScript", fontAwesomeClassname: "simple-icons:javascript", style: { backgroundColor: "#000000", color: "#F7DF1E" } },
        { skillName: "ReactJS", fontAwesomeClassname: "simple-icons:react", style: { color: "#61DAFB" } },
        { skillName: "NodeJS", fontAwesomeClassname: "devicon-plain:nodejs-wordmark", style: { color: "#339933" } },
        { skillName: "NPM", fontAwesomeClassname: "simple-icons:npm", style: { color: "#CB3837" } },
        { skillName: "Yarn", fontAwesomeClassname: "simple-icons:yarn", style: { color: "#2C8EBB" } },
        { skillName: "Gatsby", fontAwesomeClassname: "simple-icons:gatsby", style: { color: "#663399" } },
        { skillName: "Flutter", fontAwesomeClassname: "simple-icons:flutter", style: { color: "#02569B" } },
      ],
    },
    {
      titleKey: "skills.cloud.title",
      fileName: "CloudInfraImg",
      skillsKeys: [
        "skills.cloud.skills.0",
        "skills.cloud.skills.1",
        "skills.cloud.skills.2",
        "skills.cloud.skills.3",
      ],
      softwareSkills: [
        { skillName: "GCP", fontAwesomeClassname: "simple-icons:googlecloud", style: { color: "#4285F4" } },
        { skillName: "AWS", fontAwesomeClassname: "simple-icons:amazonaws", style: { color: "#FF9900" } },
        { skillName: "Azure", fontAwesomeClassname: "simple-icons:microsoftazure", style: { color: "#0089D6" } },
        { skillName: "Firebase", fontAwesomeClassname: "simple-icons:firebase", style: { color: "#FFCA28" } },
        { skillName: "PostgreSQL", fontAwesomeClassname: "simple-icons:postgresql", style: { color: "#336791" } },
        { skillName: "MongoDB", fontAwesomeClassname: "simple-icons:mongodb", style: { color: "#47A248" } },
        { skillName: "Docker", fontAwesomeClassname: "simple-icons:docker", style: { color: "#1488C6" } },
        { skillName: "Kubernetes", fontAwesomeClassname: "simple-icons:kubernetes", style: { color: "#326CE5" } },
      ],
    },
    {
      titleKey: "skills.design.title",
      fileName: "DesignImg",
      skillsKeys: [
        "skills.design.skills.0",
        "skills.design.skills.1",
        "skills.design.skills.2",
      ],
      softwareSkills: [
        { skillName: "Adobe XD", fontAwesomeClassname: "simple-icons:adobexd", style: { color: "#FF2BC2" } },
        { skillName: "Figma", fontAwesomeClassname: "simple-icons:figma", style: { color: "#F24E1E" } },
        { skillName: "Adobe Illustrator", fontAwesomeClassname: "simple-icons:adobeillustrator", style: { color: "#FF7C00" } },
        { skillName: "Inkscape", fontAwesomeClassname: "simple-icons:inkscape", style: { color: "#000000" } },
      ],
    },
  ],
};

const competitiveSites = {
  competitiveSites: [
    { siteName: "LeetCode", iconifyClassname: "simple-icons:leetcode", style: { color: "#F79F1B" }, profileLink: "https://leetcode.com/layman_brother/" },
    { siteName: "HackerRank", iconifyClassname: "simple-icons:hackerrank", style: { color: "#2EC866" }, profileLink: "https://www.hackerrank.com/layman_brother" },
    { siteName: "Codechef", iconifyClassname: "simple-icons:codechef", style: { color: "#5B4638" }, profileLink: "https://www.codechef.com/users/ashutosh_1919" },
    { siteName: "Codeforces", iconifyClassname: "simple-icons:codeforces", style: { color: "#1F8ACB" }, profileLink: "http://codeforces.com/profile/layman_brother" },
    { siteName: "Hackerearth", iconifyClassname: "simple-icons:hackerearth", style: { color: "#323754" }, profileLink: "https://www.hackerearth.com/@ashutosh391" },
    { siteName: "Kaggle", iconifyClassname: "simple-icons:kaggle", style: { color: "#20BEFF" }, profileLink: "https://www.kaggle.com/laymanbrother" },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Indian Institute of Information Technology Kurnool",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "iiitk_logo.png",
      alt_name: "IIITDM Kurnool",
      duration: "2016 - 2020",
      descriptionKeys: [
        "education.iiitk.desc.0",
        "education.iiitk.desc.1",
        "education.iiitk.desc.2",
      ],
      website_link: "http://iiitk.ac.in",
    },
    {
      title: "Indiana University Bloomington",
      subtitle: "M.S. in Computer Science",
      logo_path: "iu_logo.png",
      alt_name: "Indiana University Bloomington",
      duration: "2021 - 2023",
      descriptionKeys: [
        "education.iu.desc.0",
        "education.iu.desc.1",
        "education.iu.desc.2",
      ],
      website_link: "https://www.indiana.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    { title: "Machine Learning", subtitle: "- Andrew Ng", logo_path: "stanford_logo.png", certificate_link: "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM", alt_name: "Stanford University", color_code: "#8C151599" },
    { title: "Deep Learning", subtitle: "- Andrew Ng", logo_path: "deeplearning_ai_logo.png", certificate_link: "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G", alt_name: "deeplearning.ai", color_code: "#00000099" },
    { title: "ML on GCP", subtitle: "- GCP Training", logo_path: "google_logo.png", certificate_link: "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647", alt_name: "Google", color_code: "#0C9D5899" },
    { title: "Data Science", subtitle: "- Alex Aklson", logo_path: "ibm_logo.png", certificate_link: "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5", alt_name: "IBM", color_code: "#1F70C199" },
    { title: "Big Data", subtitle: "- Kim Akers", logo_path: "microsoft_logo.png", certificate_link: "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view", alt_name: "Microsoft", color_code: "#D83B0199" },
    { title: "Advanced Data Science", subtitle: "- Romeo Kienzler", logo_path: "ibm_logo.png", certificate_link: "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH", alt_name: "IBM", color_code: "#1F70C199" },
    { title: "Advanced ML on GCP", subtitle: "- GCP Training", logo_path: "google_logo.png", certificate_link: "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV", alt_name: "Google", color_code: "#0C9D5899" },
    { title: "DL on Tensorflow", subtitle: "- Laurence Moroney", logo_path: "deeplearning_ai_logo.png", certificate_link: "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8", alt_name: "deeplearning.ai", color_code: "#00000099" },
    { title: "Fullstack Development", subtitle: "- Jogesh Muppala", logo_path: "coursera_logo.png", certificate_link: "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA", alt_name: "Coursera", color_code: "#2A73CC" },
    { title: "Kuberenetes on GCP", subtitle: "- Qwiklabs", logo_path: "gcp_logo.png", certificate_link: "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750", alt_name: "GCP", color_code: "#4285F499" },
    { title: "Cryptography", subtitle: "- Saurabh Mukhopadhyay", logo_path: "nptel_logo.png", certificate_link: "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_", alt_name: "NPTEL", color_code: "#FFBB0099" },
    { title: "Cloud Architecture", subtitle: "- Qwiklabs", logo_path: "gcp_logo.png", certificate_link: "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2", alt_name: "GCP", color_code: "#4285F499" },
  ],
};

const experience = {
  titleKey: "experience.title",
  subtitleKey: "experience.subtitle",
  descriptionKey: "experience.description",
  header_image_path: "experience.svg",
  sections: [
    {
      titleKey: "experience.sections.work.title",
      work: true,
      experiences: [
        {
          title: "Machine Learning Engineer",
          company: "TikTok Inc.",
          company_url: "https://www.tiktok.com/en/",
          logo_path: "tiktok_logo.png",
          duration: "June 2023 - Present",
          location: "San Jose, CA, USA",
          descriptionKey: "experience.sections.work.experiences.0.description",
          color: "#000000",
        },
        {
          title: "Associate AI Engineer",
          company: "Legato Health Technology",
          company_url: "https://legatohealthtech.com/",
          logo_path: "legato_logo.png",
          duration: "June 2020 - Aug 2021",
          location: "Hyderabad, Telangana",
          descriptionKey: "experience.sections.work.experiences.1.description",
          color: "#0879bf",
        },
        {
          title: "Android and ML Developer",
          company: "Muffito Incorporation",
          company_url: "https://www.linkedin.com/company/muffito-inc/about/",
          logo_path: "muffito_logo.png",
          duration: "May 2018 - Oct 2018",
          location: "Pune, Maharashtra",
          descriptionKey: "experience.sections.work.experiences.2.description",
          color: "#9b1578",
        },
        {
          title: "Android Developer",
          company: "FreeCopy Pvt. Ltd.",
          company_url: "https://www.linkedin.com/company/freecopy/about/",
          logo_path: "freecopy_logo.png",
          duration: "Nov 2017 - Dec 2017",
          location: "Ahmedabad, Gujarat",
          descriptionKey: "experience.sections.work.experiences.3.description",
          color: "#fc1f20",
        },
      ],
    },
    {
      titleKey: "experience.sections.internships.title",
      experiences: [
        {
          title: "Machine Learning Intern",
          company: "TikTok Inc.",
          company_url: "https://www.tiktok.com/en/",
          logo_path: "tiktok_logo.png",
          duration: "May 2022 - Aug 2022",
          location: "San Francisco, USA",
          descriptionKey: "experience.sections.internships.experiences.0.description",
          color: "#000000",
        },
        {
          title: "Data Science Research Intern",
          company: "Delhivery Pvt. Ltd.",
          company_url: "https://www.delhivery.com/",
          logo_path: "delhivery_logo.png",
          duration: "May 2019 - Sept 2019",
          location: "Gurgaon, Haryana",
          descriptionKey: "experience.sections.internships.experiences.1.description",
          color: "#ee3c26",
        },
        {
          title: "Data Science Intern",
          company: "Intel Indexer LLC",
          company_url: "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
          logo_path: "intel_logo.jpg",
          duration: "Nov 2018 - Dec 2018",
          location: "Work From Home",
          descriptionKey: "experience.sections.internships.experiences.2.description",
          color: "#0071C5",
        },
      ],
    },
    {
      titleKey: "experience.sections.volunteerships.title",
      experiences: [
        {
          title: "Google Explore ML Facilitator",
          company: "Google",
          company_url: "https://about.google/",
          logo_path: "google_logo.png",
          duration: "June 2019 - April 2020",
          location: "Hyderabad, Telangana",
          descriptionKey: "experience.sections.volunteerships.experiences.0.description",
          color: "#4285F4",
        },
        {
          title: "Microsoft Student Partner",
          company: "Microsoft",
          company_url: "https://www.microsoft.com/",
          logo_path: "microsoft_logo.png",
          duration: "Aug 2019 - May 2020",
          location: "Hyderabad, Telangana",
          descriptionKey: "experience.sections.volunteerships.experiences.1.description",
          color: "#D83B01",
        },
        {
          title: "Mozilla Campus Captain",
          company: "Mozilla",
          company_url: "https://www.mozilla.org/",
          logo_path: "mozilla_logo.png",
          duration: "Oct 2019 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          descriptionKey: "experience.sections.volunteerships.experiences.2.description",
          color: "#000000",
        },
        {
          title: "Developer Students Club Member",
          company: "DSC IIITDM Kurnool",
          company_url: "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
          logo_path: "dsc_logo.png",
          duration: "Jan 2018 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          descriptionKey: "experience.sections.volunteerships.experiences.3.description",
          color: "#0C9D58",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Work From Home",
          descriptionKey: "experience.sections.volunteerships.experiences.4.description",
          color: "#181717",
        },
      ],
    },
  ],
};

const projectsHeader = {
  titleKey: "projects.title",
  descriptionKey: "projects.description",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  titleKey: "publications.title",
  descriptionKey: "publications.description",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

const contactPageData = {
  contactSection: {
    titleKey: "contact.contactSection.title",
    profile_image_path: "animated_ashutosh.png",
    descriptionKey: "contact.contactSection.description",
  },
  blogSection: {
    titleKey: "contact.blogSection.title",
    subtitleKey: "contact.blogSection.subtitle",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    titleKey: "contact.addressSection.title",
    subtitle: "Saratoga Ave, San Jose, CA, USA 95129",
    locality: "San Jose",
    country: "USA",
    region: "California",
    postalCode: "95129",
    streetAddress: "Saratoga Avenue",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};